/**
 * Gruppiert Changelog-Einträge nach Release-Version.
 *
 * Die Reihenfolge der Gruppen bleibt wie geliefert (neueste zuerst); innerhalb einer
 * Gruppe stehen Security und Features vor Bugfixes und Updates. Die erste Zeile jeder
 * Gruppe mit Version trägt die Überschrift (`header`), alle anderen null.
 */
const CATEGORY_ORDER = ['security', 'feature', 'bugfix', 'improvement'];

const categoryRank = (category: string): number => {
  const i = CATEGORY_ORDER.indexOf(category);
  return i === -1 ? CATEGORY_ORDER.length : i;
};

export function withVersionHeaders<T extends { version?: string | null; category: string }>(
  entries: T[],
): { entry: T; header: string | null }[] {
  const groups: T[][] = [];
  for (const entry of entries) {
    const last = groups[groups.length - 1];
    if (last && (last[0].version ?? null) === (entry.version ?? null)) last.push(entry);
    else groups.push([entry]);
  }
  return groups.flatMap((group) =>
    [...group]
      .sort((a, b) => categoryRank(a.category) - categoryRank(b.category))
      .map((entry, i) => ({ entry, header: i === 0 ? (entry.version ?? null) : null })),
  );
}
